import { useEffect } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApi } from './api';
import { useAuth } from './auth';
import { browserTimeZone } from './dates';

/** The signed-in user's profile, admin flag and org-creation allowance. */
export function useMe() {
  const api = useApi();
  const { user } = useAuth();
  return useQuery({ queryKey: ['me'], queryFn: api.me, enabled: Boolean(user) });
}

/**
 * Saves the browser's time zone to the profile the first time we see the
 * user. After that it changes only from Account, so a deliberate choice
 * isn't overwritten when they travel.
 */
export function useTimeZoneSync() {
  const api = useApi();
  const me = useMe();
  const queryClient = useQueryClient();
  const save = useMutation({
    mutationFn: api.setTimeZone,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['me'] }),
  });
  const missing = me.data && me.data.timeZone === null;
  useEffect(() => {
    if (missing && save.isIdle) save.mutate(browserTimeZone());
  }, [missing, save]);
}
